import { Briefcase, Layers, Settings, BarChart, Coffee, Code, Database, Smartphone, Cloud, Users, TestTube2, Palette, Bug, Brain, Bot, Zap, Eye, MessageSquare, BarChart3, Cpu, Network } from 'lucide-react';

export const liveCourses = [
    {
        id: 'l1',
        slug: 'java-enterprise-development',
        title: 'Java Core + Advance',
        price: '10125',
        originalPrice: '12500',
        level: 'Beginner to Advanced',
        isLive: true,
        category: 'live',
        duration: '3 Months',
        lectures: '35+',
        mode: 'Live Online',
        language: 'Hindi/English',
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        startDate: '2025-09-04',
        banner: {
            title: 'Java Core + Advance',
            subtitle: 'Begin with Java Web Development',
            background: 'bg-gradient-to-r from-red-600 to-orange-500',
            Icon: Coffee
        },
        description: 'Java is a widely-used, high-level programming language known for its versatility, reliability, and portability. It is a foundational language in software development, powering web applications, mobile apps, and enterprise systems. This live course is designed to take learners from fundamental concepts to advanced programming techniques, suitable for individuals with some prior coding experience.',
        overview: 'Whether you\'re looking to enhance your existing skills or start a new journey in software development, this comprehensive live course will guide you through the essentials of Java and beyond with real-time instructor guidance.',
        highlights: [
            'Premium Java Course',
            'Live & Recorded Classes',
            'Assignments & Online Test',
            'Classroom jaisi learning',
            'Access to our Placement Cell'
        ],
        whyOsop: [
            'India\'s most premium coding class',
            '26+ Years of Technology Training',
            'Zero Error Programming',
            'Strong Conceptual & Practical Knowledge'
        ],
        liveFeatures: [
            'Live Interactive Sessions',
            'Real-time Doubt Resolution',
            'Live Coding Practice',
            'Group Discussions',
            'Live Project Work',
            'Industry Expert Mentorship',
            'Live Mock Interviews',
            '24/7 Support'
        ],
        learningFormat: {
            duration: '3-4 months',
            mode: 'Live Online',
            schedule: 'Weekend/Weekday batches available',
            effort: '15-20 hours/week recommended',
            includes: [
                'Live HD Video Sessions',
                'Real-time Hands-on Projects',
                'Live Assignments & Quizzes',
                'Live Doubt Resolution',
                'Certificate of Completion'
            ]
        },
        curriculum: [
            {
                title: 'Java Basics',
                topics: [
                    '• What is Java?',
                    '• Why Java?',
                    '• History & Applications of Java',
                    '• Features, Versions & Advantages',
                    '• Setting up the Java Environment'
                ]
            },
            {
                title: 'Java Fundamentals',
                topics: [
                    '• Java Data Types',
                    '• Variables and Constants',
                    '• Comments in Java',
                    '• Output with System.out.print()',
                    '• Input Handling',
                    '• Type Conversion'
                ]
            },
            {
                title: 'Operators in Java',
                topics: [
                    '• Arithmetic Operators',
                    '• Comparison Operators',
                    '• Logical Operators',
                    '• Assignment Operators',
                    '• Bitwise Operators',
                    '• Ternary Operator'
                ]
            },
            {
                title: 'Control Statements',
                topics: [
                    '• Conditional Statements (if, switch)',
                    '• Looping Statements (for, while, do-while)',
                    '• Break and Continue Statements'
                ]
            },
            {
                title: 'Java Arrays',
                topics: [
                    '• Introduction to Arrays',
                    '• Creating Arrays',
                    '• Accessing Array Elements',
                    '• Multi-Dimensional Arrays',
                    '• Array Methods'
                ]
            },
            {
                title: 'Methods in Java',
                topics: [
                    '• Defining Methods',
                    '• Calling Methods',
                    '• Method Overloading',
                    '• Variable Length Arguments',
                    '• Return Types and Parameters'
                ]
            },
            {
                title: 'Object-Oriented Programming (OOP) Concepts',
                topics: [
                    '• Introduction to OOP',
                    '• Classes and Objects',
                    '• Encapsulation',
                    '• Inheritance',
                    '• Polymorphism',
                    '• Abstraction'
                ]
            },
            {
                title: 'Exception Handling',
                topics: [
                    '• Understanding Exceptions',
                    '• Types of Exceptions',
                    '• Try, Catch, Finally Blocks',
                    '• Throwing Exceptions',
                    '• Custom Exception Classes'
                ]
            },
            {
                title: 'Advanced Java',
                topics: [
                    '• Java Collections Framework',
                    '  - Introduction to Collections',
                    '  - List, Set, Map Interfaces',
                    '  - ArrayList, HashSet, HashMap',
                    '  - Iterators and Enhanced for Loop',
                    '• Java Streams API',
                    '  - Introduction to Streams',
                    '  - Stream Operations (filter, map, reduce)',
                    '  - Collecting Results',
                    '• Java Input/Output (I/O)',
                    '  - File Handling',
                    '  - Reading and Writing Files',
                    '  - Serialization and Deserialization'
                ]
            },
            {
                title: 'Web Development with Java',
                topics: [
                    '• Servlets',
                    '  - Introduction to Servlets',
                    '  - Lifecycle of a Servlet',
                    '  - Handling HTTP Requests and Responses',
                    '  - Session Management',
                    '• JavaServer Pages (JSP)',
                    '  - Introduction to JSP',
                    '  - JSP Lifecycle',
                    '  - JSP Tags and Expressions',
                    '  - Integrating JSP with Servlets',
                    '• Java Database Connectivity (JDBC)',
                    '  - Introduction to JDBC',
                    '  - Establishing Database Connections',
                    '  - Executing SQL Queries',
                    '  - Handling Transactions and Exceptions'
                ]
            }
        ],
        prerequisites: 'Basic knowledge of programming concepts is required before joining this course to ensure a smooth learning experience.',
        skills: [
            'Java Programming',
            'Object-Oriented Programming',
            'Web Development with Java',
            'Database Programming',
            'Enterprise Application Development'
        ],
        tools: [
            'Java Development Kit (JDK)',
            'VS Code',
            'Eclipse',
            'IntelliJ IDEA',
            'Apache Tomcat'
        ]
    },
    {
        id: 'l2',
        slug: 'python-data-analysis',
        title: 'Python for Data Analytics',
        price: '10125',
        originalPrice: '12500',
        level: 'Beginner to Advanced',
        isLive: true,
        category: 'live',
        duration: '4 Months',
        lectures: '45+',
        mode: 'Live Online',
        language: 'Hindi/English',
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        startDate: '2025-09-09',
        banner: {
            title: 'Python',
            subtitle: 'for Data Analytics',
            background: 'bg-gradient-to-r from-green-500 to-blue-600',
            Icon: Brain
        },
        description: 'Comprehensive live course covering Python programming, data analysis, machine learning, and AI for data science. Perfect for aspiring data scientists and machine learning engineers.',
        overview: 'This intensive 12-week live course takes you from Python basics to advanced AI-powered data science, including machine learning, deep learning, MLOps, and real-world projects.',
        highlights: [
            'Premium Coding Course',
            'Experienced Trainer',
            'Live Instructor-Led Sessions',
            'Real-time Assignments',
            'Assessment/Online Test',
          
            'Placement Assistance'
        ],
        whyOsop: [
            'India\'s most premium coding class',
            '26+ Years of Technology Training',
            'Zero Error Programming',
            'Strong Conceptual & Practical Knowledge'
        ],
        liveFeatures: [
            'Live Interactive Sessions',
            'Real-time Doubt Resolution',
            'Live Coding Practice',
            'Group Discussions',
            'Live Project Work',
            'Industry Expert Mentorship',
            'Live Mock Interviews',
            '24/7 Support'
        ],
        learningFormat: {
            duration: '3 months (12 weeks)',
            mode: 'Live Online',
            schedule: 'Weekend/Weekday batches available',
            effort: '15-20 hours/week recommended',
            includes: [
                'Live HD Video Sessions',
                'Real-time Hands-on Projects',
                'Live Assignments & Quizzes',
                'Live Doubt Resolution',
                'Certificate of Completion'
            ]
        },
        curriculum: [
            {
                title: ' Python Foundations & Data Handling',
                topics: [
                    ' Python Basics for Data Science',
                    '  - Introduction to Python & Data Science Landscape',
                    '  - Installing & Setting up Python (Jupyter Notebook, VS Code, Anaconda)',
                    '  - Python Data Types: Lists, Tuples, Dictionaries, Sets',
                    '  - Loops, Functions, and List Comprehensions',
                    '  - Object-Oriented Programming (OOP) in Python',
                    '  - Hands-on Assignment: Data processing using Python functions and loops',
                    ' NumPy & Pandas for Data Manipulation',
                    '  - Introduction to NumPy: Arrays, Indexing, Slicing, Broadcasting',
                    '  - Pandas DataFrames & Series: Loading, Filtering, Grouping',
                    '  - Data Cleaning & Transformation: Handling Missing Data, Encoding',
                    '  - Performance Optimization using Vectorization',
                    '  - Hands-on Assignment: Handling messy datasets and preparing them for analysis',
                    ' Data Visualization & Exploratory Data Analysis (EDA)',
                    '  - Introduction to Matplotlib & Seaborn',
                    '  - Data Visualization Best Practices',
                    '  - Exploratory Data Analysis: Univariate, Bivariate, Multivariate Analysis',
                    '  - Feature Engineering for Machine Learning',
                    '  - Hands-on Project: EDA on a Real-World Dataset (e.g., Titanic Dataset, IPL Data)',
                    ' Databases & Web Scraping',
                    '  - SQL for Data Science: Joins, Aggregations, Window Functions',
                    '  - Introduction to NoSQL (MongoDB)',
                    '  - Web Scraping using BeautifulSoup & Scrapy',
                    '  - API Data Extraction (JSON, REST APIs)',
                    '  - Hands-on Project: Scraping job postings & analyzing job market trends'
                ]
            }
            
           
        ],
        prerequisites: 'Basic computer literacy and mathematical aptitude. No prior programming experience required.',
        skills: [
            'Python Programming',
            'Data Analysis & Visualization',
            'Machine Learning',
            'Deep Learning',
            'Natural Language Processing',
            'Big Data Processing',
            'MLOps & Model Deployment',
            'Cloud Computing for Data Science'
        ],
        tools: [
            'Python',
            'Jupyter Notebook',
            'Anaconda',
            'NumPy',
            'Pandas',
            'Matplotlib',
            'Seaborn',
            'Scikit-learn',
            'TensorFlow',
            'Keras',
            'PySpark',
            'Docker',
            'AWS/GCP/Azure'
        ],
        jobDeliverables: [
            '10+ Real-World Projects',
            'Resume & Portfolio Building',
            'Hands-on with AI-driven Data Science',
            'Capstone Project for Job Readiness'
        ],
        targetAudience: [
            'College students preparing for Data Science & AI careers',
            'Aspiring Machine Learning Engineers & Data Scientists',
            'Enthusiasts looking to upskill for future AI-driven jobs'
        ],
        outcomes: [
            'Industry-Ready: Master Python, ML, AI, and Cloud Deployment',
            'Portfolio-Driven: Work on Real-World Projects for Resume',
            'Future-Proof Skills: AI, MLOps, and Autonomous Data Science'
        ]
    },
    {
        id: 'l3',
        slug: 'fullstack-mern',
        title: 'Live Full-Stack Web Development using MERN Stack',
        price: '13500',
        originalPrice: '15000',
        level: 'Beginner to Advanced',
        isLive: true,
        category: 'live',
        duration: '4-6 months',
        lectures: '55+',
        mode: 'Live Online',
        language: 'Hindi/English',
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        startDate: '2025-09-14',
        banner: {
            title: 'Full-Stack MERN Bootcamp',
            subtitle: 'MERN Stack Pro',
            background: 'bg-gradient-to-r from-gray-700 to-gray-900',
            Icon: Layers
        },
        description: 'Master frontend & backend development using React, Node, MongoDB, and Express. Build full-stack web applications from scratch with real-time projects and career-ready skills.',
        overview: 'This comprehensive 12-16 week live course covers everything from web development basics to advanced MERN stack implementation, deployment, and interview preparation.',
        highlights: [
            'Premium Coding Course',
            'Experienced Trainer',
            'Live Instructor-Led Sessions',
            'Real-time Assignments',
            'Assessment/Online Test',

            'Placement Assistance'
        ],
        whyOsop: [
            'India\'s most premium coding class',
            '26+ Years of Technology Training',
            'Zero Error Programming',
            'Strong Conceptual & Practical Knowledge'
        ],
        liveFeatures: [
            '100% Live Instructor-Led Training',
            'Real-Time Doubt Resolution',
            'Live Coding Practice',
            'Group Discussions',
            'Live Project Work',
            'Industry Expert Mentorship',
            'Live Mock Interviews',
            '24/7 Support'
        ],
        learningFormat: {
            duration: '12-16 weeks',
            mode: '100% Live Online',
            schedule: 'Weekdays or Weekends Batch Options',
            effort: '15-20 hours/week recommended',
            includes: [
                'Live HD Video Sessions',
                'Real-time Hands-on Projects',
                'Live Assignments & Quizzes',
                'Live Doubt Resolution',
                'Certificate of Completion'
            ]
        },
        tools: [
            'VS Code',
            'GitHub',
            'MongoDB Atlas',
            'Postman',
            'Vercel',
            'Render'
        ],
        curriculum: [
            {
                title: ' Web Development Basics',
                topics: [
                    '• HTML5 + CSS3 Crash Course (Live Practice)',
                    '• Responsive Design (Flexbox, Grid, Media Queries)',
                    '• JavaScript (ES6+): Variables, Functions, Arrays, Objects',
                    '• DOM Manipulation & Events',
                    '• Mini Project: Live Portfolio Website'
                ]
            },
            {
                title: ' Git, GitHub & Advanced JavaScript',
                topics: [
                    '• Git Basics, Branching, Pull Requests',
                    '• Fetch API, Promises, Async/Await',
                    '• Error Handling & Form Validation',
                    '• Activity: Build a Form with Validation + Git Deployment'
                ]
            },
            {
                title: ' React.js (Frontend Framework)',
                topics: [
                    '• Component Architecture, Props, State',
                    '• Hooks: useState, useEffect, useRef',
                    '• Routing using react-router-dom',
                    '• Form Handling & Conditional Rendering',
                    '• API Calls with Axios',
                    '• Project: Live Weather or Task Manager App'
                ]
            },
            {
                title: ' Node.js + Express.js (Backend)',
                topics: [
                    '• Introduction to Node.js & Express.js',
                    '• RESTful APIs: GET, POST, PUT, DELETE',
                    '• Middlewares, Routers',
                    '• JWT Authentication (Login/Register Flow)',
                    '• Using Postman for API Testing',
                    '• Project: Auth + Blog Backend API'
                ]
            },
            {
                title: ' MongoDB + Mongoose',
                topics: [
                    '• NoSQL vs SQL',
                    '• MongoDB Basics, Collections, Documents',
                    '• Mongoose Models & Relationships',
                    '• CRUD Operations with MongoDB',
                    '• MongoDB Atlas Integration',
                    '• Project: Product Database with API Integration'
                ]
            },
            {
                title: ' Full MERN Integration',
                topics: [
                    '• Connecting React Frontend to Node + Express API',
                    '• Auth Integration (Login/Signup)',
                    '• Protected Routes',
                    '• File Upload (Multer)',
                    '• Filters, Search, and Pagination',
                    '• Project: Full MERN App – E-Commerce or Task Dashboard'
                ]
            }
        
      
        ],
        prerequisites: 'Basic computer literacy. No prior programming experience required.',
        skills: [
            'HTML5 & CSS3',
            'JavaScript (ES6+)',
            'React.js',
            'Node.js',
            'Express.js',
            'MongoDB',
            'Git & GitHub',
            'RESTful APIs',
            'JWT Authentication',
            'Deployment & DevOps'
        ],
        capstoneProjects: [
            'E-Commerce Website',
            'LMS – Online Course Platform',
            'Blogging Platform',
            'Job Board with Auth + Admin Panel'
        ],
        assessments: [
            'Weekly Live Tests & Mini Quizzes',
            'Real-Time Coding Assignments',
            'Final Project Presentation & Review'
        ],
        certification: 'OSOP Coding Certified Full-Stack Developer (Live MERN Track) - Zero Error Programming Standards',
        courseObjectives: [
            'Master frontend & backend development using React, Node, MongoDB, and Express',
            'Build full-stack web applications from scratch',
            'Understand deployment, authentication, API integration, and real-time features',
            'Gain career-ready skills for full-stack developer roles'
        ]
    },
    {
        id: 'l4',
        slug: 'c-cpp-programming',
        title: 'Complete C++ with OOPS & STL',
        price: '6885',
        originalPrice: '8500',
        level: 'Beginner to Expert',
        isLive: true,
        category: 'live',
         duration: '3-4 Months',
        lectures: '60+',
        mode: 'Live Online',
        language: 'Hindi/English',
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        startDate: '2025-09-19',
        banner: {
            title: 'Complete C++ with OOPS & STL',
            subtitle: 'Get Expertise in C++',
            background: 'bg-gradient-to-r from-blue-600 to-blue-400',
            Icon: Code
        },
        description: 'New Live Class for Complete C++ with OOPS & STL by #BajpaiSir who known for #ZeroErrorProgramming. #BajpaiSir trained 15000+ IT Engineers in classroom training. Feel like real classroom in Live Class.',
        overview: '#10DaysFree Live Classes, Pay Fee on 11th Day.',
        highlights: [
            'Premium Coding Course',
            'Experienced Trainer',
            'Live Instructor-Led Sessions',
            'Real-time Assignments',
            'Assessment/Online Test',
            'Certification',
            'Placement Assistance'
        ],
        whyOsop: [
            'India\'s most premium coding class',
            '26+ Years of Technology Training',
            'Zero Error Programming',
            'Strong Conceptual & Practical Knowledge'
        ],
        liveFeatures: [
            '100% Live Instructor-Led Training',
            'Real-Time Doubt Resolution',
            'Live Coding Practice',
            'Group Discussions',
            'Live Project Work',
            'Industry Expert Mentorship',
            'Live Mock Interviews',
            '24/7 Support'
        ],
        learningFormat: {
            duration: '8-10 weeks',
            mode: '100% Live Online',
            schedule: 'Weekdays or Weekends Batch Options',
            effort: '10-15 hours/week recommended',
            includes: [
                'Live HD Video Sessions',
                'Real-time Hands-on Projects',
                'Live Assignments & Quizzes',
                'Live Doubt Resolution',
                'Certificate of Completion'
            ]
        },
        tools: [
            'Turbo C++',
            'VS Code',
            'GCC Compiler'
        ],
        curriculum: [
            {
                title: "Module 1: Core C++ Programming (Foundation)",
                topics: [
                    "• Introduction to Programming & C++ Language",
                    "  - History, uses, compiler setup, structure of a C++ program",
                    "• Variables, Data Types & Operators",
                    "  - Constants, type casting, ASCII, bitwise operators",
                    "• Control Structures",
                    "  - if/else, switch, loops (for, while, do-while), nested loops",
                    "• Functions & Recursion",
                    "  - Function declaration, definition, recursion basics",
                    "• Pointers & Memory",
                    "  - Basics, pointer arithmetic, dynamic memory allocation",
                    "• Arrays & Strings",
                    "  - 1D/2D arrays, string functions, matrix operations",
                    "• User-defined Data Types",
                    "  - Structures, unions, typedef, enums",
                    "• File Handling",
                    "  - File operations, modes, file pointers"
                ]
            },
            {
                title: "Module 2: C++ Programming with OOP Concepts",
                topics: [

                    "  - cout/cin, namespaces, reference variables, std::string class",
                    "• Object-Oriented Programming",
                    "  - Classes & Objects, Encapsulation, Abstraction",
                    "  - Inheritance (Single, Multiple, Multilevel, Hierarchical, Hybrid)",
                    "  - Polymorphism: Compile-Time & Run-Time",
                    "  - Object Passing and Returning",
                    "• Advanced C++ Concepts",
                    "  - this pointer",
                    "  - Scope Resolution Operator",
                    "  - Static Members & Functions",
                    "  - Constructors & Destructors (Types, Overloading)",
                    "  - Inline Functions",
                    "  - Default Arguments",
                    "• Operator Overloading",
                    "  - Arithmetic & Relational Operator Overloading",
                    "  - Overloading << and >> (Insertion & Extraction)",
                    "• Friend Functions & Classes",
                    "  - Use cases and syntax",
                    "• Memory & Exception Handling",
                    "  - Dynamic Object Creation",
                    "  - Exception Handling (try, catch, throw)",
                    "• Templates & Generic Programming",
                    "  - Function Templates",
                    "  - Class Templates",
                    "• File Handling in C++",
                    "  - File Streams and Modes",
                    "  - Text and Binary File Operations",
                    "  - I/O Formatting & Manipulators",
                    "  - User-defined Manipulators",
                    "• OOP Relationships",
                    "  - IS-A vs HAS-A",
                    "  - Generalization and Specialization",
                    "  - Abstract Classes & Virtual Functions"
                ]
            },
            {
                title: "Module 3: C++ STL (Standard Template Library)",
                topics: [
                    "• C++ STL Basics",
                    "  - Containers, Algorithms, Iterators, Functors",
                    "• Basic Containers",
                    "  - vector, list, deque, array, stack, queue, priority_queue",
                    "• Associative Containers",
                    "  - set, multiset, map, multimap, unordered_set, unordered_map",
                    "• Modern C++ Features",
                    "  - pair, tuple, emplace, move, auto, lambdas",
                    "• STL Algorithms",
                    "  - sort/search, reverse, count/find, swap, accumulate etc."
                ]
            },
        ],
        prerequisites: 'Basic computer literacy. No prior programming experience required.',
        skills: [
            'C Programming Fundamentals',
            'C++ Object-Oriented Programming',
            'Data Structures & Algorithms',
            'Memory Management',
            'File Handling',
            'Exception Handling',
            'Templates & STL',
            'Logical Thinking',
            'Clean Coding Practices'
        ],
        projects: [
            'Basic Calculator',
            'Student Record Management System',
            'Class-based Bank Application',
            'Library Management System',
            'Simple Banking System with File Handling'
        ],
        assessments: [
            'Weekly Coding Challenges',
            'Live Practice Sessions',
            'Final Evaluation Based on Capstone Project',
            '1-on-1 Doubt Sessions Every Week'
        ],
        certification: 'OSOP Coding Certificate in C & C++ - Based on Live Attendance + Final Project - Tagged under Zero Error Programming',
        courseObjectives: [
            'Build strong fundamentals in structured and object-oriented programming',
            'Master both C (system-level) and C++ (OOP-level) skills',
            'Solve real-world problems and understand internal working of code',
            'Develop logical thinking, memory management, and clean coding practices'
        ]
    },
    {
        id: 'l5',
        slug: 'dsa-using-c++',
        title: 'DSA Using C++',
        price: '4050',
        originalPrice: '5000',
        level: 'Beginner to Advanced',
        isLive: true,
        category: 'live',
        duration: '2 Months',
        lectures: '25+',
        mode: 'Live Online',
        language: 'Hindi/English',
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        startDate: '2025-09-24',
        banner: {
            title: 'DSA Using C++',
            subtitle: 'Crack Your Dream Tech Job',
            background: 'bg-gradient-to-r from-purple-600 to-indigo-600',
            Icon: Network
        },
        description: 'DSA Using C++ is a live, instructor-led program crafted for students and aspiring developers who aim to crack technical interviews, coding rounds, and gain deep problem-solving expertise using C++. This course is powered by Zero Error Programming and backed by 26+ years of training excellence at OSOP Coding. Learn, practice, and master Data Structures and Algorithms from the ground up with real-time assignments, live support, and placement guidance.',
        overview: 'Master DSA and problem-solving for product-based companies with live classes, real-time assignments, and placement support. Get certified and become interview-ready with advanced C++ and DSA expertise.',
        highlights: [
            'Live Instructor-Led Classes',
            'Problem-Solving from Basic to Advanced',
            'Real-Time DSA Assignments',
            'Weekly Doubt Sessions',
            'Interview Preparation & Mock Rounds',
            'Certification + Placement Assistance'
        ],
        skills: [
            'Core Data Structures & Algorithms',
            'Advanced C++ for Competitive Coding',
            'Time & Space Complexity Analysis',
            'Problem-Solving for Product-Based Companies'
        ],
        tools: [
            'C++ Compiler (Turbo C++ / VS Code / Online Judges)',
            'Postman (for logic testing)',
            'LeetCode',
            'CodeStudio',
            'HackerRank',
            'GFG'
        ],
        curriculum: [
            { title: 'Module 1: Introduction to DSA', topics: ['What & Why of DSA', 'Applications in Placements & Competitions'] },
            { title: 'Module 2: DSA Prerequisites in C++', topics: ['Functions, Arrays, Pointers', 'Classes, Objects, Reference Variables', 'Modular Programming'] },
            { title: 'Module 3: Time & Space Complexity', topics: ['Big-O, Big-Theta, Big-Omega Notation', 'Dry Runs and Logical Analysis'] },
            { title: 'Module 4: Array Address Calculations', topics: ['Memory Mapping in 1D, 2D, 3D Arrays'] },
            { title: 'Module 5: Stacks', topics: ['Theory, Applications', 'Static & Dynamic Implementation', 'Classic Problems'] },
            { title: 'Module 6: Queues', topics: ['Linear, Circular, Priority Queue', 'Implementation and Use Cases'] },
            { title: 'Module 7: Linked Lists', topics: ['Singly, Doubly, Circular', 'Node Operations & Real-Life Apps'] },
            { title: 'Module 8: Recursion & Backtracking', topics: ['Function Stack Flow', 'N-Queens, Maze Problems'] },
            { title: 'Module 9: Sorting Algorithms', topics: ['Bubble, Selection, Insertion', 'Merge, Quick, Heap, Radix Sort'] },
            { title: 'Module 10: Searching Techniques', topics: ['Linear vs Binary Search', 'Edge Cases in Searching'] },
            { title: 'Module 11: Trees', topics: ['Binary Trees & BSTs', 'AVL Trees, Traversals'] },
            { title: 'Module 12: Graphs', topics: ['Representation: List, Matrix', 'Traversals: BFS, DFS', 'Dijkstra’s, Bellman-Ford'] },
            { title: 'Module 13: Hashing', topics: ['Hash Tables, Collisions', 'Linear Probing, Chaining'] },
            { title: 'Module 14: Dynamic Programming', topics: ['Memoization vs Tabulation', 'Classic DP Problems'] },
            { title: 'Module 15: Greedy Algorithms', topics: ['Concept + Real Interview Problems', 'Greedy vs DP Thinking'] }
        ],
        projects: [
            'Weekly Problem Sets',
            'Mini Projects per Data Structure',
            'Final DSA Interview Round Project'
        ],
        certification: 'OSOP Certified DSA Placement Developer (C++ Track) – Based on Attendance + Final Project + Assessment',
        placementSupport: [
            'Resume Building',
            'Profile Optimization',
            'Mock Interviews',
            'Company-Specific DSA Question Practice'
        ]
    },
    {
        id: 'l6',
        slug: 'springboot-backend',
        title: 'SpringBoot Backend Development',
        price: '13500',
        originalPrice: '15000',
        level: 'Intermediate',
        isLive: true,
        category: 'live',
        duration: '3-4 months',
        lectures: '55+',
        mode: 'Live Online',
        language: 'Hindi/English',
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        startDate: '2025-09-29',
        banner: {
            title: 'SpringBoot Backend Pro',
            subtitle: 'Build Scalable REST APIs with Java & Spring Boot',
            background: 'bg-gradient-to-r from-green-600 to-green-400',
            Icon: Coffee
        },
        description: 'SpringBoot Backend Development is a live, instructor-led program designed to help students and professionals build scalable, secure, and production-ready backend applications using Spring Boot, Spring MVC, and Spring Data JPA. Learn everything from REST API development to authentication and database integration, with real-world projects and expert guidance.',
        overview: 'Master backend development with Java, Spring Boot, and JPA. Build RESTful APIs, integrate databases, implement authentication, and deploy production-ready systems with hands-on projects and expert mentorship.',
        highlights: [
            'Instructor-Led Live Classes',
            'Real-Time API & Project Development',
            'RESTful Architecture Mastery',
            'Weekly Assignments & Live Coding Support',
            'Final Project Review & Certification'
        ],
        skills: [
            'Backend Architecture with Spring Boot',
            'RESTful API Development',
            'Relational Database Management (JPA + MySQL)',
            'Secure Authentication (Spring Security + JWT)',
            'API Documentation & Testing (Swagger, Postman)',
            'End-to-End Backend System Building'
        ],
        tools: [
            'Java 17+',
            'Spring Boot 3.x',
            'Spring MVC',
            'Spring Data JPA',
            'Hibernate ORM',
            'MySQL',
            'H2',
            'MongoDB (Optional)',
            'Postman',
            'Swagger UI',
            'IntelliJ IDEA / STS / Eclipse',
            'Maven',
            'Git',
            'GitHub',
            'Render',
            'Railway',
            'Docker (Optional)'
        ],
        prerequisites: 'Core Java (available as a separate module)',
        learningFormat: {
            duration: '6–8 Weeks',
            mode: '100% Live | Instructor-Led',
            schedule: 'Weekdays or Weekends Batch Options',
            effort: '10-15 hours/week recommended',
            includes: [
                'Live HD Video Sessions',
                'Real-time Hands-on Projects',
                'Live Assignments & Quizzes',
                'Live Doubt Resolution',
                'Certificate of Completion'
            ]
        },
        curriculum: [
            { title: 'Module 1: Spring Boot Basics', topics: ['Spring Framework vs Spring Boot', 'Project Setup using Spring Initializr', 'Maven & Dependencies', 'Spring Boot Annotations & DevTools'] },
            { title: 'Module 2: RESTful API Development', topics: ['REST Architecture & HTTP Methods', 'Creating CRUD APIs using @RestController', 'Request/Response Mapping', 'API Response Structure'] },
            { title: 'Module 3: Database Integration with JPA', topics: ['Introduction to JPA & Hibernate', 'Connecting to MySQL / H2', 'Entity Creation & Mapping', 'One-to-One, One-to-Many, Many-to-Many', 'Repository Layer & Custom Queries'] },
            { title: 'Module 4: Data Validation & Exception Handling', topics: ['Bean Validation using @Valid, @NotNull, @Size, etc.', 'Global Exception Handling with @ControllerAdvice', 'Custom Exception Classes', 'Creating a Standard API Response Format'] },
            { title: 'Module 5: Authentication & Security', topics: ['Spring Security Configuration', 'BCrypt Password Encryption', 'Role-Based Access Control', 'JWT Token Authentication Flow', 'Secure Route Handling'] },
            { title: 'Module 6: API Testing & Documentation', topics: ['Postman API Testing', 'Swagger Integration with SpringDoc', 'Auto-generated API Docs', 'Versioning Best Practices'] },
            { title: 'Module 7: File Upload & Static Resource Handling', topics: ['Uploading Images & Files', 'Saving to Local Directory or DB', 'Serving Files through API'] },
            { title: 'Module 8: Capstone Project', topics: ['Choose One Project:', 'Blog Backend API', 'User Management System', 'Inventory/Product Management System', 'Task Manager / To-Do API System', 'Includes: CRUD Operations, Auth & Role Management, File Upload, Swagger Docs, Clean Architecture'] }
        ],
        projects: [
            'Blog Backend API',
            'User Management System',
            'Inventory/Product Management System',
            'Task Manager / To-Do API System'
        ],
        certification: 'OSOP Coding Certificate in SpringBoot Backend Development – Awarded after project evaluation + attendance-based eligibility'
    },
    {
        id: 'l7',
        slug: 'python-django',
        title: 'Python + Django Web Development',
        price: '11250',
        originalPrice: '12500',
        level: 'Beginner to Advanced',
        isLive: true,
        category: 'live',
        duration: '3-4 months',
        lectures: '55+',
        mode: 'Live Online',
        language: 'Hindi/English',
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        startDate: '2025-10-04',
        banner: {
            title: 'Python + Django Pro',
            subtitle: 'From Basics to Building Web Apps',
            background: 'bg-gradient-to-r from-green-700 to-green-500',
            Icon: Code
        },
        description: 'The Python + Django Web Development course is a live instructor-led program that teaches students how to build dynamic, secure, and real-world web applications using Python and Django. Starting from Python programming fundamentals, this course advances into the Django framework, enabling students to build modern web backends, APIs, and server-side logic with ease.',
        overview: 'Master Python programming and Django web development from scratch. Build real-world web apps, REST APIs, and admin panels with hands-on projects, live support, and expert mentorship.',
        highlights: [
            '100% Live Interactive Sessions',
            'From Python Basics to Full Django Projects',
            'Real-Time Web App Development',
            'Assignments, Quizzes & Project Guidance',
            'Final Project Certification by OSOP Coding',
            'Interview-Oriented Django Training (Optional Add-on)'
        ],
        skills: [
            'Python Programming (Core + OOP)',
            'Django MVC Framework (MTV Architecture)',
            'REST APIs with Django REST Framework',
            'Template Rendering and Dynamic Frontend',
            'Database Handling with Django ORM',
            'User Authentication, File Uploads, and Admin Panel'
        ],
        tools: [
            'Python 3.11+',
            'Django 5.x',
            'SQLite / PostgreSQL / MySQL',
            'Django REST Framework (DRF)',
            'VS Code / PyCharm',
            'Postman',
            'Git',
            'GitHub',
            'Bootstrap (for frontend integration)'
        ],
        prerequisites: 'No prior coding knowledge required',
        learningFormat: {
            duration: '6–8 Weeks',
            mode: 'Instructor-Led | 100% Live | Hands-on Web Development',
            schedule: 'Weekdays or Weekends Batch Options',
            effort: '10-15 hours/week recommended',
            includes: [
                'Live HD Video Sessions',
                'Real-time Hands-on Projects',
                'Live Assignments & Quizzes',
                'Live Doubt Resolution',
                'Certificate of Completion'
            ]
        },
        curriculum: [
            { title: 'Module 1: Python Programming (Core + OOP)', topics: ['Python Installation & Setup', 'Variables, Data Types, Input/Output', 'Conditional Statements & Loops', 'Functions, Modules & File Handling', 'Exception Handling', 'Object-Oriented Programming in Python (Classes, Objects, Inheritance)', 'Assignments: Console-based calculator, simple file-based to-do list, OOP mini-project'] },
            { title: 'Module 2: Web Fundamentals for Django', topics: ['How the Web Works (HTTP, URL, DNS)', 'Introduction to MVC/MVT Frameworks', 'Basics of HTML, CSS, Bootstrap (for Django Templates)', 'Django Project Setup & Structure'] },
            { title: 'Module 3: Django Basics', topics: ['Django Admin, Apps & URL Routing', 'Views & Templates – Dynamic HTML Rendering', 'Models & ORM (Database Handling)', 'CRUD Operations using Django ORM', 'Django Forms & Validation', 'Mini Project: Notes App or Blog System'] },
            { title: 'Module 4: Django Advanced Concepts', topics: ['Django Messages Framework', 'Sessions & Cookies', 'Static Files and Media Files', 'Django User Authentication (Login, Signup, Logout, Password Reset)', 'Role-Based Access Control', 'Django Signals'] },
            { title: 'Module 5: Django REST Framework (API Development)', topics: ['Introduction to REST APIs', 'Serializers & ViewSets', 'GET, POST, PUT, DELETE API Methods', 'JWT Authentication', 'Consuming APIs via Postman / Frontend', 'Build an API for a Blog or To-Do App'] },
            { title: 'Module 6: Final Project – Web App (Full-Stack)', topics: ['Build a fully working web application with:', 'Authentication', 'Admin Panel', 'CRUD Features', 'File Upload', 'REST APIs', 'Responsive UI with Bootstrap', 'Example Projects:', 'Blog Management System', 'Portfolio CMS', 'Inventory Manager', 'Online Feedback or Contact Manager', 'Job Board / Resume Tracker'] }
        ],
        projects: [
            'Blog Management System',
            'Portfolio CMS',
            'Inventory Manager',
            'Online Feedback or Contact Manager',
            'Job Board / Resume Tracker'
        ],
        certification: 'OSOP Coding Certificate in Python + Django Web Development – Awarded after project review + performance in class + attendance'
    },
    {
        id: 'l8',
        slug: 'sql-for-beginners',
        title: 'SQL for Beginners',
        price: '2430',
        originalPrice: '3000',
        level: 'Beginner-Friendly',
        isLive: true,
        category: 'live',
        duration: '1 Month',
        lectures: '15+',
        mode: 'Live Online',
        language: 'Hindi/English',
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        startDate: '2025-10-09',
        banner: {
            title: 'SQL for Beginners',
            subtitle: 'Master Database Querying with MySQL',
            background: 'bg-gradient-to-r from-blue-700 to-indigo-800',
            Icon: Database
        },
        description: 'SQL (Structured Query Language) is the industry-standard language for managing relational databases. This live instructor-led course is tailored for beginners aiming to master SQL fundamentals, MySQL syntax, database design, and real-time data querying. Learn how to retrieve, update, and analyze data efficiently — a must-have skill for developers, analysts, and data enthusiasts.',
        overview: 'Master SQL from scratch with live classes, hands-on assignments, and real-world projects. Learn MySQL, database design, querying, and data analysis for career-ready skills.',
        highlights: [
            'Premium Live Classes with Expert Trainers',
            'From Basics to Advanced SQL Topics',
            'Real-Time Assignments & Practice Queries',
            'Weekly Quizzes & Class Demos',
            'Certification on Completion',
            'Strong Conceptual + Practical Training'
        ],
        skills: [
            'Mastery in SQL Query Writing',
            'Understanding of RDBMS, Tables & Indexes',
            'Joins, Aggregations, Subqueries & Views',
            'Hands-on with MySQL Workbench & CLI',
            'Data Filtering, Formatting & Privileges',
            'Schema Design Best Practices'
        ],
        tools: [
            'MySQL Workbench',
            'MySQL Command Line Client (CLI)',
            'DB Diagrams & Query Editors',
            'OSOP SQL Lab Sheets'
        ],
        prerequisites: 'No prior DB experience needed',
        learningFormat: {
            duration: '4–5 Weeks',
            mode: '100% Live | Instructor-Led',
            schedule: 'Weekdays or Weekends Batch Options',
            effort: '6-8 hours/week recommended',
            includes: [
                'Live HD Video Sessions',
                'Real-time Hands-on Practice',
                'Live Assignments & Quizzes',
                'Live Doubt Resolution',
                'Certificate of Completion'
            ]
        },
        curriculum: [
            { title: 'Module 1: Introduction to Databases', topics: ['What is a Database?', 'File System vs Database System', 'Real-life Need for Databases'] },
            { title: 'Module 2: DBMS & RDBMS Basics', topics: ['What is DBMS?', 'Types of DBMS (Relational, NoSQL)', 'DBMS vs RDBMS'] },
            { title: 'Module 3: MySQL Overview', topics: ['What is MySQL?', 'History, Installation, Tools', 'Introduction to MySQL Workbench & CLI'] },
            { title: 'Module 4: Getting Started with SQL', topics: ['What is SQL? What can it do?', 'SQL Syntax & SQL Standards', 'DDL, DML, DQL, TCL, DCL Commands'] },
            { title: 'Module 5: Data Types & Table Creation', topics: ['SQL Data Types (Numeric, String, Date/Time)', 'Creating Tables using CREATE', 'Inserting Data using INSERT', 'Viewing Data with SELECT'] },
            { title: 'Module 6: Data Retrieval & Filtering', topics: ['SELECT, WHERE, DISTINCT, ORDER BY', 'Logical Operators: AND, OR, NOT', 'BETWEEN, IN, LIKE, Wildcards'] },
            { title: 'Module 7: Data Modification', topics: ['UPDATE Records', 'DELETE Records', 'Altering Table Structures (ALTER TABLE)'] },
            { title: 'Module 8: SQL Constraints', topics: ['PRIMARY KEY, FOREIGN KEY', 'NOT NULL, UNIQUE, CHECK, DEFAULT'] },
            { title: 'Module 9: Date, Time, and REGEXP', topics: ['Working with Date & Time Data Types', 'Using Date Functions: NOW(), CURDATE(), DATEDIFF()', 'Regular Expressions with REGEXP'] },
            { title: 'Module 10: Aggregate Functions & Grouping', topics: ['SUM(), COUNT(), AVG(), MAX(), MIN()', 'GROUP BY, HAVING Clause'] },
            { title: 'Module 11: Subqueries', topics: ['Nested Queries in SELECT, WHERE, FROM', 'Correlated vs Non-Correlated Subqueries'] },
            { title: 'Module 12: Joins in SQL', topics: ['INNER JOIN', 'LEFT JOIN, RIGHT JOIN', 'FULL OUTER JOIN', 'SELF JOIN'] },
            { title: 'Module 13: Indexing & Views', topics: ['Creating & Dropping Indexes', 'Creating Views for Query Abstraction', 'Dropping Views'] },
            { title: 'Module 14: User Management & Privileges', topics: ['GRANTING Access with GRANT', 'Removing Access with REVOKE', 'Introduction to User Roles in MySQL'] }
        ],
        assignments: [
            'Weekly SQL Sheets (MCQs + Queries)',
            'Real-time Practice Datasets'
        ],
        projects: [
            'Project: Design and Query a Small DB (e.g., Student Management System)'
        ],
        certification: 'OSOP Coding Certificate in SQL for Beginners – Awarded after class participation, assignments, and final quiz/project'
    },
    {
        id: 'l9',
        slug: 'c-for-beginners',
        title: 'C for Beginners',
        rating: 4.4,
        interested: '120k+',
        price: '3645',
        originalPrice: '4500',
        level: 'Beginner',
        isLive: true,
        category: 'live',
        duration: '2 Months',
        lectures: '25+',
        mode: 'Live Online',
        language: 'Hindi/English',
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        startDate: '2025-10-14',
        banner: {
            title: 'C for Beginners',
            subtitle: 'Master Programming from the Core',
            background: 'bg-gradient-to-r from-blue-800 to-blue-600',
            Icon: Code
        },
        description: 'C Programming is a foundational language that forms the backbone of modern computing. From system-level programming to embedded systems and real-time operating systems, C helps you understand how software truly interacts with hardware. This live instructor-led course introduces you to C from scratch—no prior experience needed. You\'ll learn everything from basic syntax to memory management, functions, arrays, pointers, and file operations.',
        overview: 'Learn C programming from the ground up with live coding, real-time assignments, and project-based learning. Build a strong foundation in programming logic, memory management, and structured design.',
        highlights: [
            'Premium Live Coding Sessions',
            'Real-Time Assignments + Live Coding Practice',
            'Project-Based Learning Approach',
            'Quizzes & Doubt Clearing Weekly',
            'Certification After Completion',
            'Guided by Experienced Trainers'
        ],
        whyOsop: [
            'India’s Most Premium Coding Class',
            '26+ Years of Proven Technology Training',
            'Zero Error Programming Methodology',
            'Focus on Conceptual + Practical Learning'
        ],
        skills: [
            'Core Programming Logic',
            'C Programming Syntax and Structure',
            'Problem Solving using Loops, Conditions, Arrays',
            'Understanding of Memory and Pointers',
            'Modular & Structured Programming Design'
        ],
        tools: [
            'Turbo C++ (Windows)',
            'VS Code + GCC Compiler (Cross-platform)'
        ],
        prerequisites: 'None (Absolute Beginner Friendly)',
        learningFormat: {
            duration: '4–6 Weeks',
            mode: '100% Live | Instructor-Led | Beginner Level',
            schedule: 'Weekdays or Weekends Batch Options',
            effort: '6-8 hours/week recommended',
            includes: [
                'Live HD Video Sessions',
                'Real-time Hands-on Practice',
                'Live Assignments & Quizzes',
                'Live Doubt Resolution',
                'Certificate of Completion'
            ]
        },
        curriculum: [
            { title: 'Module 1: Getting Started with C', topics: ['What is C & Why Learn It?', 'History and Applications of C', 'Introduction to Computers and Operating Systems', 'Setting Up Turbo C++ / VS Code + GCC'] },
            { title: 'Module 2: C Basics & Program Structure', topics: ['Data Types, Variables, Constants', 'Operators (Arithmetic, Relational, Logical, Bitwise)', 'ASCII and Type Casting', 'Flowcharts & Algorithms', 'Structure of a C Program', 'Types of Errors in C'] },
            { title: 'Module 3: Conditional Logic', topics: ['if, else if, else, Nested Conditions', 'switch-case Statements', '?: Ternary Operator', 'Logical Operators & Comparisons'] },
            { title: 'Module 4: Loops & Control Flow', topics: ['for, while, do-while Loops', 'Nested Loops for Pattern Printing', 'break, continue, goto Usage', 'Number System Introduction'] },
            { title: 'Module 5: Functions & Storage', topics: ['Function Declaration & Definitions', 'Function Parameters and Return Types', 'Recursion Basics', 'Storage Classes (auto, extern, static, register)', 'Preprocessor Directives (#define, #include, #ifdef)'] },
            { title: 'Module 6: Arrays, Strings & Pointers', topics: ['Single & Multi-Dimensional Arrays', 'Strings & Character Arrays', 'String Functions (strlen, strcpy, etc.)', 'Pointers: Basics, Types, and Pointer Arithmetic', 'Pointer to Array and Functions', 'Dynamic Memory Allocation with malloc, calloc'] },
            { title: 'Module 7: User-Defined Data Types', topics: ['struct, union, typedef, enum', 'Structure Manipulation & Nesting', 'Use Cases in Real Projects'] },
            { title: 'Module 8: File Handling in C', topics: ['File Opening Modes', 'Reading & Writing Files', 'File Pointer Movement Functions', 'fopen, fscanf, fprintf, fread, fwrite'] }
        ],
        assignments: [
            'Weekly Lab Tasks',
            'Problem Solving Sheets'
        ],
        projects: [
            'Mini Projects (e.g., Student Database, Simple Calculator, Attendance Tracker)'
        ],
        certification: 'OSOP Coding Certificate in C Programming – Issued upon successful project submission and participation'
    },
    {
        id: 'l10',
        slug: 'oops-cpp-live',
        title: 'OOPs in C++',
        rating: 4.5,
        interested: '110k+',
        price: '2430',
        originalPrice: '3000',
        level: 'Beginner to Advanced',
        isLive: true,
        category: 'live',
        duration: '45 Days',
        lectures: '20+',
        mode: 'Live Online',
        language: 'Hindi/English',
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        startDate: '2025-10-19',
        banner: {
            title: 'OOPs in C++',
            subtitle: 'Master Object-Oriented Programming with C++',
            background: 'bg-gradient-to-r from-blue-700 to-blue-500',
            Icon: Code
        },
        description: 'C++ is a powerful and efficient programming language that combines the low-level features of C with the flexibility and power of Object-Oriented Programming (OOP). This live, instructor-led course introduces students to OOP concepts using C++, building a strong foundation in software design and modular programming. Whether you are new to programming or want to enhance your C++ knowledge, this course walks you through everything from the basics to advanced OOP topics, enriched with real-world examples and hands-on coding projects.',
        overview: 'Master OOP concepts and C++ programming from scratch. Build real-world projects, understand deep software design, and gain hands-on experience with live coding and expert mentorship.',
        highlights: [
            'Live Expert-Led Sessions',
            'Hands-On OOPs Project Implementation',
            'Real-Time Coding Practice + Weekly Assignments',
            'Conceptual Clarity with Visual Explanations',
            'Certification on Completion',
            'Doubt-Solving & Practice Sessions'
        ],
        whyOsop: [
            'India’s Most Premium Coding Class',
            '26+ Years of Technology & Engineering Training',
            'Zero Error Programming Pedagogy',
            'Focus on Deep Concepts & Hands-On Practice'
        ],
        skills: [
            'Object-Oriented Design using C++',
            'Class-Based Modular Architecture',
            'C++ Syntax, Memory Management, and File Handling',
            'Operator Overloading, Exception Handling, and Templates',
            'Problem-Solving Using OOP Principles'
        ],
        tools: [
            'Turbo C++ (Windows)',
            'Visual Studio Code + GCC Compiler',
            'Online C++ Debuggers & Visualizers'
        ],
        prerequisites: 'Basics of C Programming',
        learningFormat: {
            duration: '5–6 Weeks',
            mode: '100% Live | Instructor-Led | Hands-on OOP Training',
            schedule: 'Weekdays or Weekends Batch Options',
            effort: '8-10 hours/week recommended',
            includes: [
                'Live HD Video Sessions',
                'Real-time Hands-on Projects',
                'Live Assignments & Quizzes',
                'Live Doubt Resolution',
                'Certificate of Completion'
            ]
        },
        curriculum: [
            { title: 'Module 1: C++ Fundamentals', topics: ['Introduction to C++ & its Features', 'cin, cout, endl', 'Namespaces in C++', 'Reference Variables', 'Function Overloading', 'C++ Strings (std::string operations)'] },
            { title: 'Module 2: Core OOP Concepts', topics: ['What is OOP? Why OOP over Procedural?', '4 Pillars of OOP:', 'Class & Object', 'Encapsulation', 'Abstraction', 'Inheritance & Polymorphism', 'Access Specifiers: public, private, protected'] },
            { title: 'Module 3: Classes & Functions', topics: ['this Pointer', 'Scope Resolution Operator', 'Passing and Returning Objects', 'Inline Functions', 'Constructors and Destructors (Types & Uses)'] },
            { title: 'Module 4: Memory & Static Management', topics: ['Static Data Members & Functions', 'Object Counters using Static', 'Dynamic Objects using Pointers', 'Dynamic Constructors'] },
            { title: 'Module 5: Advanced OOP Features', topics: ['Friend Functions & Friend Classes', 'Operator Overloading (+, -, ==, <<, >>)', 'Default Arguments in Functions', 'Function Overriding & Virtual Functions', 'Abstract Classes & Pure Virtual Functions', 'IS-A & HAS-A Relationships', 'Generalization vs Specialization'] },
            { title: 'Module 6: Exception Handling', topics: ['Try-Catch Blocks', 'Multiple Catch & Nested Try', 'Throwing Custom Exceptions'] },
            { title: 'Module 7: Templates & File Handling', topics: ['Function & Class Templates', 'Input/Output with File Streams', 'Text File and Binary File Operations', 'User-Defined Manipulators', 'File I/O + Operator Overloading'] }
        ],
        projects: [
            'Student Record Management System',
            'Library Management System',
            'Simple Bank or Billing System'
        ],
        certification: 'OSOP Coding Certificate in OOPs with C++ – Awarded on completion of project + class participation'
    },
    {
        id: 'l11',
        slug: 'java-for-beginners-live',
        title: 'Java for Absolute Beginners',
        rating: 4.5,
        interested: '100k+',
        price: '5265',
        originalPrice: '6500',
        level: 'Beginner',
        isLive: true,
        category: 'live',
        duration: '2 Months',
        lectures: '25+',
        mode: 'Live Online',
        language: 'Hindi/English',
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        startDate: '2025-10-24',
        banner: {
            title: 'Java for Absolute Beginners',
            subtitle: 'Start Your Programming Journey with Java',
            background: 'bg-gradient-to-r from-yellow-600 to-orange-500',
            Icon: Code
        },
        description: 'Java for Absolute Beginners is a live instructor-led course carefully designed for individuals with no prior programming experience. Java is one of the world’s most powerful and widely-used languages, forming the foundation for Android apps, enterprise systems, web applications, and more. This course guides you from basic syntax to object-oriented programming (OOP), file handling, and real-world coding with clear explanations and hands-on exercises to ensure complete understanding.',
        overview: 'Start your programming journey with Java! Learn Java syntax, OOP, file handling, and real-world coding from scratch with live sessions, hands-on projects, and expert mentorship.',
        highlights: [
            'Live Instructor-Led Sessions',
            'Zero-Error Programming Approach',
            'Hands-On Projects & Weekly Assignments',
            'Beginner-Friendly with No Prerequisites',
            'Final Assessment & Certification',
            'Conceptual + Practical Training'
        ],
        whyOsop: [
            'India’s Most Premium Coding Class',
            '26+ Years of Technology & Programming Education',
            'Strong Focus on Logic, OOP, and Clean Code',
            'Beginner to Confident Java Developer Path'
        ],
        skills: [
            'Java Syntax, Compilation, and Execution',
            'Control Structures and Loops',
            'Object-Oriented Programming (OOP)',
            'Java File Handling, Arrays, and Strings',
            'Exception Handling and Wrapper Classes',
            'Real-world Java Project Building'
        ],
        tools: [
            'Java Development Kit (JDK)',
            'VS Code, Notepad, Command Line',
            'Online Java Compiler for Practice'
        ],
        prerequisites: 'None (Absolute Beginner Friendly)',
        learningFormat: {
            duration: '4–6 Weeks',
            mode: '100% Live | Instructor-Led | Hands-On Learning',
            schedule: 'Weekdays or Weekends Batch Options',
            effort: '8-10 hours/week recommended',
            includes: [
                'Live HD Video Sessions',
                'Real-time Hands-on Projects',
                'Live Assignments & Quizzes',
                'Live Doubt Resolution',
                'Certificate of Completion'
            ]
        },
        curriculum: [
            { title: 'Module 1: Introduction to Java', topics: ['What is Java? Features & Applications', 'Java Editions (SE, EE), Compilation Flow', 'JVM, JRE, JDK Explained', 'Setting Up Java + First Java Program'] },
            { title: 'Module 2: Syntax, Variables & Data Types', topics: ['Java Syntax, main() Method, Print Statements', 'Variables, Literals, Constants', 'Data Types: Primitive & Non-Primitive', 'ASCII & Unicode in Java'] },
            { title: 'Module 3: Control Flow & Operators', topics: ['Conditional Statements: if, else, switch', 'Loops: for, while, do-while, for-each', 'Operators: Arithmetic, Logical, Bitwise', 'Type Casting & Operator Precedence'] },
            { title: 'Module 4: Object-Oriented Programming (OOP)', topics: ['Classes and Objects', 'OOP Concepts: Inheritance, Polymorphism', 'Access Modifiers (public, private, etc.)', 'this Keyword Usage'] },
            { title: 'Module 5: Methods & Constructors', topics: ['Creating and Using Methods', 'Method Overloading', 'Types of Constructors: Default, Parameterized, Copy', 'Constructor Overloading', 'Static Methods & Object Class'] },
            { title: 'Module 6: Arrays & Strings', topics: ['Single-Dimensional and Multi-Dimensional Arrays', 'Array Traversal and Manipulation', 'String Objects, String Methods (length, substring, equals, etc.)'] },
            { title: 'Module 7: Exception Handling', topics: ['What is an Exception?', 'Try-Catch-Finally Blocks', 'Handling Multiple Exceptions', 'Custom Exception Introduction'] },
            { title: 'Module 8: Wrapper Classes & Type Conversion', topics: ['Wrapper Classes (Integer, Double, Boolean, etc.)', 'Auto-boxing and Unboxing', 'Type Conversion Techniques'] },
            { title: 'Module 9: Advanced OOP Concepts', topics: ['Abstract Classes vs Interfaces', 'Method Overriding', 'Real Use Cases of Inheritance and Abstraction'] },
            { title: 'Module 10: Java Special Features', topics: ['Introduction to varargs', 'Important Java Keywords: final, static, super, etc.'] },
            { title: 'Module 11: File Handling', topics: ['File I/O Basics', 'Reading and Writing to Files', 'Using File, FileWriter, BufferedReader Classes'] },
            { title: 'Module 12: Real-World Applications', topics: ['Practical Coding Exercises', 'Mini Project: Student Info System / Calculator / Task Manager', 'Final Live Demo & Code Review'] }
        ],
        projects: [
            'Mini Project: Student Info System',
            'Calculator',
            'Task Manager'
        ],
        certification: 'OSOP Coding Certificate in Java Programming – Issued after successful completion of the final project and class participation'
    },
    {
        id: 'l12',
        slug: 'java-core-advance',
        title: 'Java Core + Advanced',
        rating: 4.8,
        interested: '280k+',
        price: '10125',
        originalPrice: '12500',
        level: 'Beginner to Advanced',
        isLive: true,
        category: 'live',
        duration: '3 Months',
        lectures: '35+',
        mode: 'Live Online',
        language: 'Hindi/English',
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        startDate: '2025-10-29',
        banner: {
            title: 'Java Core + Advanced',
            subtitle: 'From Fundamentals to Web Development with Java',
            background: 'bg-gradient-to-r from-red-700 to-orange-600',
            Icon: Coffee
        },
        description: 'This all-in-one Java Core + Advanced course is a live instructor-led training program for individuals who want to master Java programming—from absolute basics to professional-level development. Starting with programming fundamentals, this course guides you through OOP, exception handling, collections, file I/O, and eventually into advanced backend technologies like Servlets, JSP, JDBC, and project-based learning. Whether you\'re aiming for software development, backend engineering, or preparing for real-world projects—this course is your launchpad to Java mastery.',
        overview: 'Master Java from basics to advanced web development. Learn OOP, collections, JDBC, Servlets, JSP, and build real-world projects with live guidance and hands-on coding.',
        highlights: [
            '100% Live Instructor-Led Classes',
            'Beginner to Advanced Pathway',
            'Real-Time Coding Assignments & Projects',
            'Core Java + Web Development Modules',
            'Final Project + Certification',
            'Doubt Sessions + Online Tests'
        ],
        whyOsop: [
            'India’s Most Premium Coding Class',
            '26+ Years of Training Excellence',
            'Zero Error Programming Approach',
            'Focused on Conceptual + Practical Skills'
        ],
        skills: [
            'Java Programming Fundamentals',
            'Object-Oriented Design & Best Practices',
            'Exception Handling & File Management',
            'Java Collections & Streams',
            'JDBC & Database Access',
            'Servlet & JSP-based Web Application Development'
        ],
        tools: [
            'JDK (Java Development Kit)',
            'VS Code',
            'IntelliJ IDEA',
            'Eclipse',
            'Apache Tomcat',
            'MySQL / PostgreSQL',
            'JDBC',
            'JSP',
            'Servlets'
        ],
        prerequisites: 'None (Beginner Friendly)',
        learningFormat: {
            duration: '8–10 Weeks',
            mode: '100% Live | Instructor-Led | Hands-On Projects',
            schedule: 'Weekdays or Weekends Batch Options',
            effort: '10-15 hours/week recommended',
            includes: [
                'Live HD Video Sessions',
                'Real-time Hands-on Projects',
                'Live Assignments & Quizzes',
                'Live Doubt Resolution',
                'Certificate of Completion'
            ]
        },
        curriculum: [
            { title: 'MODULE 1: Introduction to Java & Environment Setup', topics: ['What is Java? History & Features', 'JDK, JRE, JVM Explained', 'Java Compilation and Execution', 'Setting up Java in VS Code / IntelliJ / CMD'] },
            { title: 'MODULE 2: Java Syntax, Data Types & Variables', topics: ['Writing First Java Program', 'Print Statements, Comments, Identifiers', 'Primitive and Non-Primitive Data Types', 'ASCII vs Unicode', 'Input Handling & Type Casting'] },
            { title: 'MODULE 3: Operators & Control Flow', topics: ['Arithmetic, Relational, Logical, Bitwise Operators', 'if, else, switch Statements', 'Loops: for, while, do-while, for-each', 'Break, Continue, Nested Loops'] },
            { title: 'MODULE 4: Object-Oriented Programming (OOP)', topics: ['Classes and Objects', 'Encapsulation, Inheritance, Polymorphism, Abstraction', 'this keyword, Access Modifiers', 'Static Members & Static Block'] },
            { title: 'MODULE 5: Methods & Constructors', topics: ['Method Declaration and Invocation', 'Constructor Types: Default, Parametrized, Copy', 'Method Overloading & Constructor Overloading', 'Varargs in Java'] },
            { title: 'MODULE 6: Arrays and Strings', topics: ['Single-Dimensional and Multi-Dimensional Arrays', 'Array Traversal, Search & Sort', 'Strings in Java (String, StringBuilder, StringBuffer)', 'Common String Methods & Operations'] },
            { title: 'MODULE 7: Exception Handling', topics: ['Try-Catch-Finally Blocks', 'Multiple Catch, Nested Try', 'Throwing and Creating Custom Exceptions', 'throws, throw, and Exception Propagation'] },
            { title: 'MODULE 8: Wrapper Classes & Type Conversion', topics: ['Auto-boxing and Unboxing', 'Conversions between Primitives and Wrappers', 'Usage in Collections & Parsing'] },
            { title: 'MODULE 9: Advanced OOP Concepts', topics: ['Abstract Classes & Interfaces', 'Method Overriding', 'IS-A, HAS-A Relationship', 'Real-World Design Use Cases'] },
            { title: 'MODULE 10: Java Collections Framework', topics: ['List, Set, Map Interfaces', 'ArrayList, LinkedList, HashSet, HashMap', 'Iterators & Enhanced For Loops', 'Sorting & Searching Collections'] },
            { title: 'MODULE 11: Java Streams API', topics: ['Introduction to Streams', 'Intermediate Operations: map, filter, sorted', 'Terminal Operations: collect, reduce, count', 'Use Cases with Collections'] },
            { title: 'MODULE 12: File Handling & Serialization', topics: ['File I/O using File, Scanner, BufferedReader', 'Writing & Reading Files', 'Serialization and Deserialization'] },
            { title: 'MODULE 13: JDBC – Java Database Connectivity', topics: ['Introduction to JDBC API', 'Setting Up JDBC with MySQL/PostgreSQL', 'Connection, Statement, PreparedStatement, ResultSet', 'Performing CRUD Operations', 'Transaction Management & SQL Exception Handling'] },
            { title: 'MODULE 14: Web Development with Java', topics: ['Servlets', 'Servlet Lifecycle', 'doGet(), doPost(), Response Handling', 'Cookies & Session Management', 'JSP (JavaServer Pages)', 'JSP Syntax, Scriptlets, Expressions', 'JSP Lifecycle', 'Integrating JSP with Servlets'] },
            { title: 'MODULE 15: Final Capstone Project', topics: ['Project Ideas:', 'Student Management System', 'E-Commerce Backend', 'Online Feedback System', 'Blog Management Dashboard', 'Project includes: CRUD, JDBC, JSP/Servlet, Exception Handling, Session Tracking, File Handling or Upload Feature'] }
        ],
        projects: [
            'Student Management System',
            'E-Commerce Backend',
            'Online Feedback System',
            'Blog Management Dashboard'
        ],
        certification: 'OSOP Coding Certificate in Java Core + Advanced – Issued after completion of project and final quiz',
        assignments: [
            'Weekly Coding Sheets',
            'Quizzes after Every Major Module',
            '1-on-1 Live Doubt Clearing',
            'GitHub Code Submission & Portfolio Guidance'
        ]
    },
    {
        id: 'l13',
        slug: 'devops-engineering-live',
        title: 'DevOps Engineering',
        rating: 4.9,
        interested: '180k+',
        price: '13500',
        originalPrice: '15000',
        level: 'Intermediate to Advanced',
        isLive: true,
        category: 'live',
        duration: '4-5 months',
        lectures: '150+',
        mode: 'Live Online',
        language: 'Hindi/English',
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        startDate: '2025-11-03',
        banner: {
            title: 'DevOps Engineering',
            subtitle: 'CI/CD, Cloud & Automation',
            background: 'bg-gradient-to-r from-blue-600 to-purple-600',
            Icon: Cloud
        },
        description: 'Master DevOps practices, tools, and methodologies through live interactive sessions. Learn CI/CD, containerization, cloud platforms, and infrastructure automation.',
        overview: 'This comprehensive DevOps course covers everything from version control to cloud deployment, preparing you for modern software development practices.',
        highlights: [
            'Most Premium Course',
            'Live & Recorded Classes',
            'Weekly Live Class for Doubt Solving',
            '50+ Assignments',
            'Assessment via Online Test',
            'Practical Approach',
            'Industry Recognised Certification Course',
            'Access to our Placement Portal'
        ],
        whyOsop: [
            'India\'s most premium coding class',
            '26+ Years of Technology Training',
            'Zero Error Programming',
            'Strong Conceptual & Practical Knowledge'
        ],
        liveFeatures: [
            'Live Interactive Sessions',
            'Real-time Doubt Resolution',
            'Live Hands-on Labs',
            'Cloud Platform Access',
            'Live Project Work',
            'Industry Expert Mentorship',
            'Live Mock Interviews',
            '24/7 Support'
        ],
        learningFormat: {
            duration: '4-5 months',
            mode: 'Live Online',
            schedule: 'Weekend/Weekday batches available',
            effort: '15-20 hours/week recommended',
            includes: [
                'Live HD Video Sessions',
                'Real-time Hands-on Projects',
                'Live Assignments & Quizzes',
                'Live Doubt Resolution',
                'Certificate of Completion'
            ]
        },
        curriculum: [
            {
                title: 'DevOps Fundamentals',
                topics: [
                    '• Introduction to DevOps',
                    '• DevOps Culture and Practices',
                    '• Version Control with Git',
                    '• Git Workflows and Best Practices',
                    '• GitHub/GitLab Administration'
                ]
            },
            {
                title: 'Linux & Shell Scripting',
                topics: [
                    '• Linux Fundamentals',
                    '• Shell Scripting (Bash)',
                    '• System Administration',
                    '• Process Management',
                    '• File System Operations'
                ]
            },
            {
                title: 'Containerization & Orchestration',
                topics: [
                    '• Docker Fundamentals',
                    '• Docker Images and Containers',
                    '• Docker Compose',
                    '• Kubernetes Basics',
                    '• Container Orchestration'
                ]
            },
            {
                title: 'CI/CD Pipelines',
                topics: [
                    '• Jenkins Automation',
                    '• GitHub Actions',
                    '• GitLab CI/CD',
                    '• Pipeline as Code',
                    '• Automated Testing'
                ]
            },
            {
                title: 'Cloud Platforms',
                topics: [
                    '• AWS Fundamentals',
                    '• Azure Basics',
                    '• Google Cloud Platform',
                    '• Infrastructure as Code (Terraform)',
                    '• Cloud Security'
                ]
            },
            {
                title: 'Monitoring & Logging',
                topics: [
                    '• Prometheus & Grafana',
                    '• ELK Stack (Elasticsearch, Logstash, Kibana)',
                    '• Application Monitoring',
                    '• Alerting Systems',
                    '• Performance Optimization'
                ]
            }
        ],
        tools: [
            'Git & GitHub',
            'Docker & Kubernetes',
            'Jenkins & GitHub Actions',
            'AWS/Azure/GCP',
            'Terraform & Ansible',
            'Prometheus & Grafana',
            'Linux & Shell Scripting'
        ],
        projects: [
            'Automated CI/CD Pipeline',
            'Containerized Application Deployment',
            'Multi-Cloud Infrastructure Setup',
            'Monitoring Dashboard Implementation'
        ]
    },
    {
        id: 'l14',
        slug: 'ai-ml-specialization-live',
        title: 'AI & Machine Learning Specialization',
        rating: 4.8,
        interested: '220k+',
        price: '13500',
        originalPrice: '15000',
        level: 'Intermediate to Advanced',
        isLive: true,
        category: 'live',
        duration: '5-6 months',
        lectures: '80+',
        mode: 'Live Online',
        language: 'Hindi/English',
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        startDate: '2025-11-08',
        banner: {
            title: 'AI & ML Specialization',
            subtitle: 'Deep Learning & Neural Networks',
            background: 'bg-gradient-to-r from-purple-600 to-pink-600',
            Icon: Brain
        },
        description: 'Comprehensive AI and Machine Learning course covering algorithms, deep learning, neural networks, and real-world applications.',
        overview: 'Master the fundamentals of AI/ML, build neural networks, and deploy machine learning models for real-world applications.',
        highlights: [
            'Most Premium Course',
            'Live & Recorded Classes',
            'Weekly Live Class for Doubt Solving',
            '50+ Assignments',
            'Assessment via Online Test',
            'Practical Approach',
            'Industry Recognised Certification Course',
            'Access to our Placement Portal'
        ],
        whyOsop: [
            'India\'s most premium coding class',
            '26+ Years of Technology Training',
            'Zero Error Programming',
            'Strong Conceptual & Practical Knowledge'
        ],
        liveFeatures: [
            'Live Interactive Sessions',
            'Real-time Doubt Resolution',
            'Live Coding Practice',
            'GPU Access for Training',
            'Live Project Work',
            'Industry Expert Mentorship',
            'Live Mock Interviews',
            '24/7 Support'
        ],
        learningFormat: {
            duration: '5-6 months',
            mode: 'Live Online',
            schedule: 'Weekend/Weekday batches available',
            effort: '15-20 hours/week recommended',
            includes: [
                'Live HD Video Sessions',
                'Real-time Hands-on Projects',
                'Live Assignments & Quizzes',
                'Live Doubt Resolution',
                'Certificate of Completion'
            ]
        },
        curriculum: [
            {
                title: 'Machine Learning Fundamentals',
                topics: [
                    '• Supervised vs Unsupervised Learning',
                    '• Linear & Logistic Regression',
                    '• Decision Trees & Random Forests',
                    '• Support Vector Machines',
                    '• Model Evaluation Metrics'
                ]
            },
            {
                title: 'Deep Learning & Neural Networks',
                topics: [
                    '• Neural Network Architecture',
                    '• Backpropagation Algorithm',
                    '• Convolutional Neural Networks (CNN)',
                    '• Recurrent Neural Networks (RNN)',
                    '• Transfer Learning'
                ]
            },
            {
                title: 'Natural Language Processing',
                topics: [
                    '• Text Preprocessing',
                    '• Word Embeddings',
                    '• Transformer Models',
                    '• BERT & GPT Models',
                    '• Sentiment Analysis'
                ]
            },
            {
                title: 'Computer Vision',
                topics: [
                    '• Image Processing',
                    '• Object Detection',
                    '• Image Segmentation',
                    '• Face Recognition',
                    '• Video Analysis'
                ]
            },
            {
                title: 'Model Deployment & MLOps',
                topics: [
                    '• Model Serialization',
                    '• API Development',
                    '• Cloud Deployment',
                    '• Model Monitoring',
                    '• A/B Testing'
                ]
            }
        ],
        tools: [
            'Python & Jupyter Notebooks',
            'TensorFlow & PyTorch',
            'Scikit-learn',
            'OpenCV',
            'NLTK & spaCy',
            'AWS SageMaker',
            'Google Colab'
        ],
        projects: [
            'Image Classification System',
            'Sentiment Analysis API',
            'Recommendation Engine',
            'Real-time Object Detection'
        ]
    },
    {
        id: 'l15',
        slug: 'software-testing-live',
        title: 'Software Testing & Quality Assurance',
        rating: 4.7,
        interested: '150k+',
        price: '13500',
        originalPrice: '15000',
        level: 'Beginner to Advanced',
        isLive: true,
        category: 'live',
        duration: '3-4 months',
        lectures: '80+',
        mode: 'Live Online',
        language: 'Hindi/English',
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        startDate: '2025-11-13',
        banner: {
            title: 'Software Testing',
            subtitle: 'Quality Assurance & Automation',
            background: 'bg-gradient-to-r from-green-600 to-teal-600',
            Icon: Bug
        },
        description: 'Comprehensive software testing course covering manual testing, automation, performance testing, and quality assurance methodologies.',
        overview: 'Learn testing fundamentals, automation frameworks, and best practices for ensuring software quality in real-world projects.',
        highlights: [
            'Most Premium Course',
            'Live & Recorded Classes',
            'Weekly Live Class for Doubt Solving',
            '50+ Assignments',
            'Assessment via Online Test',
            'Practical Approach',
            'Industry Recognised Certification Course',
            'Access to our Placement Portal'
        ],
        whyOsop: [
            'India\'s most premium coding class',
            '26+ Years of Technology Training',
            'Zero Error Programming',
            'Strong Conceptual & Practical Knowledge'
        ],
        liveFeatures: [
            'Live Interactive Sessions',
            'Real-time Doubt Resolution',
            'Live Testing Practice',
            'Real Project Testing',
            'Live Project Work',
            'Industry Expert Mentorship',
            'Live Mock Interviews',
            '24/7 Support'
        ],
        learningFormat: {
            duration: '3-4 months',
            mode: 'Live Online',
            schedule: 'Weekend/Weekday batches available',
            effort: '12-15 hours/week recommended',
            includes: [
                'Live HD Video Sessions',
                'Real-time Hands-on Projects',
                'Live Assignments & Quizzes',
                'Live Doubt Resolution',
                'Certificate of Completion'
            ]
        },
        curriculum: [
            {
                title: 'Testing Fundamentals',
                topics: [
                    '• Software Testing Life Cycle (STLC)',
                    '• Testing Types & Levels',
                    '• Test Case Design Techniques',
                    '• Bug Reporting & Tracking',
                    '• Test Documentation'
                ]
            },
            {
                title: 'Manual Testing',
                topics: [
                    '• Functional Testing',
                    '• Non-Functional Testing',
                    '• Usability Testing',
                    '• Compatibility Testing',
                    '• Security Testing'
                ]
            },
            {
                title: 'Automation Testing',
                topics: [
                    '• Selenium WebDriver',
                    '• TestNG Framework',
                    '• Page Object Model',
                    '• Data-Driven Testing',
                    '• Cross-Browser Testing'
                ]
            },
            {
                title: 'Performance Testing',
                topics: [
                    '• JMeter Fundamentals',
                    '• Load Testing',
                    '• Stress Testing',
                    '• Performance Monitoring',
                    '• Test Results Analysis'
                ]
            },
            {
                title: 'API Testing',
                topics: [
                    '• REST API Testing',
                    '• Postman Tool',
                    '• API Automation',
                    '• JSON & XML Handling',
                    '• API Documentation'
                ]
            },
            {
                title: 'Mobile Testing',
                topics: [
                    '• Mobile App Testing',
                    '• Appium Framework',
                    '• Device Testing',
                    '• Mobile Performance Testing',
                    '• Cross-Platform Testing'
                ]
            }
        ],
        tools: [
            'Selenium WebDriver',
            'TestNG & JUnit',
            'JMeter',
            'Postman',
            'Appium',
            'JIRA & Bugzilla',
            'TestRail'
        ],
        projects: [
            'E-commerce Website Testing',
            'Mobile App Testing Suite',
            'API Testing Framework',
            'Performance Testing Dashboard'
        ]
    }
]; 
